import { createSearchStore } from '@/stores/create-search-store';

export const useCompanySearchStore = createSearchStore({
  storeName: 'CompanySearchStore',
  defaultSortField: 'updatedAt',
  defaultItemsPerPage: 100,
});
